// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".display-card{padding:1rem;color:#ffffff}.display-card p,.display-card h1{font-weight:500}.display-type{width:50%}.display-type-thin{width:40%}.display-checkbox{width:50px}.display-num{width:25%}.flow-btn-group>button{margin-left:1rem;border-radius:0}.btn-no-display{border:none;color:inherit;background-color:inherit;padding:0}.btn-no-radius{border-radius:0}.btn-lt-gray-border{border:1px solid #dddddd;color:#666666}\n", ""]);
// Exports
module.exports = exports;
